// Animates content in and out. While `show` turns false, the last rendered children stay on screen
// for `exitMs` with a leave animation, then `fallback` (if any) animates in.
import React, { useEffect, useRef, useState } from 'react';
import '../concession.css';

const Presence = ({ show, children, fallback = null, exitMs = 320, className = '' }) => {
  const [mounted, setMounted] = useState(show);
  const [leaving, setLeaving] = useState(false);
  const last = useRef(children);
  if (show) last.current = children;

  useEffect(() => {
    if (show) {
      setMounted(true);
      setLeaving(false);
      return undefined;
    }
    if (!mounted) return undefined;
    setLeaving(true);
    const timer = setTimeout(() => {
      setMounted(false);
      setLeaving(false);
    }, exitMs);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  if (!show && !mounted) {
    return fallback ? <div className="cx-presence-fallback">{fallback}</div> : null;
  }
  return (
    <div className={`${className} ${leaving ? 'cx-presence-leave' : 'cx-presence-enter'}`} aria-hidden={leaving || undefined}>
      {show ? children : last.current}
    </div>
  );
};

export default Presence;
